export const beverageCategories = [
  {
    name: "Coffee",
    image:
      "https://cache.marriott.com/is/image/marriotts7prod/bonvoy-seoul-coffee-14153?wid=316&fit=constrain",
  },
  {
    name: "Tea",
    image:
      "https://cache.marriott.com/is/image/marriotts7prod/bonvoy_brand_mbv-1073046?wid=316&fit=constrain",
  },
  {
    name: "Juices",
    image:
      "https://cache.marriott.com/is/image/marriotts7prod/cy-selsn-the-22-juice-11454?wid=316&fit=constrain",
  },
  {
    name: "Milk",
    image:
      "https://cache.marriott.com/is/image/marriotts7prod/ar-madca-breakfast-milk-00614?wid=316&fit=constrain",
  },
  {
    name: "Water",
    image:
      "https://cache.marriott.com/is/image/marriotts7prod/si-mlesi-bottled-water-23199?wid=316&fit=constrain",
  },
  {
    name: "Soda",
    image:
      "https://cache.marriott.com/is/image/marriotts7prod/cy-bwibd-soda-market-32168?wid=316&fit=constrain",
  },
  {
    name: "Energy Drink",
    image:
      "https://cache.marriott.com/is/image/marriotts7prod/GettyImages-1309892866?wid=316&fit=constrain",
  },
  {
    name: "Beer",
    image:
      "https://cache.marriott.com/is/image/marriotts7prod/chifo-beer-1-20903?wid=316&fit=constrain",
  },
  {
    name: "Wine",
    image:
      "https://cache.marriott.com/is/image/marriotts7prod/jw-wasjw-white-wine-14577?wid=316&fit=constrain",
  },
  {
    name: "Spirits",
    image:
      "https://cache.marriott.com/is/image/marriotts7prod/br-bodbr-gina-bar-36925?wid=316&fit=constrain",
  },
];